import { VehicleListQueryRequest } from "../../../../../network/control/Vehicle";
import { InputDataListS } from "../../../../components/modal/SearchFormModal";

const FilterOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: "unityId",
    label: "Unidad",
  },
  {
    value: "zone",
    label: "Zona",
  },
  {
    value: "operator",
    label: "Agente",
  },
];

export const SearchPatrolInputList: InputDataListS = [
  {
    name: "filter",
    type: "select",
    label: "Buscar por",
    options: FilterOptions,
    cleanable: false,
  },
  {
    name: "search",
    type: "keyword",
    label: "Palabra Clave",
    placeholder: "Ingrese busqueda",
    defaultValue: "",
    // options: FilterOptions,
    // cleanable: false,
  },
  {
    name: "dpInicio",
    type: "datepicker",
    label: "Desde",
    // options: FilterOptions,
    // cleanable: false,
  },
  {
    name: "dpFinal",
    type: "datepicker",
    label: "Hasta",
    // options: FilterOptions,
    // cleanable: false,
  },
  {
    name: "searchInAll",
    type: "checkbox",
    label: "Todos los Registros",
    defaultValue: false,
    // options: FilterOptions,
    // cleanable: false,
  },
];
